// «Влияние изменения» before the archive (stage B1): how many records hold the field or the value, which views and scenarios use it;
// the person confirms knowing that. Values stay in the records, and the field or value can come back.

import { useEffect, useState } from 'react';
import { Button, Dialog } from '../ui/primitives.tsx';
import s from './archive.module.css';

interface Usage { records: number; views: string[]; automations: string[] }

export function ArchiveConfirm({ kind, id, label, onConfirm, onClose }: { kind: 'field' | 'term'; id: string; label: string; onConfirm: () => void; onClose: () => void }) {
  const [u, setU] = useState<Usage | null>(null);
  useEffect(() => { void fetch(`/api/schema/usage?${kind}=${id}`).then(async (r) => setU(r.ok ? await r.json() as Usage : { records: 0, views: [], automations: [] })); }, [kind, id]);
  const what = kind === 'field' ? 'Поле' : 'Значение';
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }} label={`${what} «${label}» в архив`}>
      <div className={s.box}>
        <h2 className={s.title}>{what} «{label}» в архив?</h2>
        {!u ? <p className={s.text}>Считаем, где используется…</p> : (
          <ul className={s.list}>
            <li>{u.records ? `${kind === 'field' ? 'Заполнено' : 'Стоит'} в записях: ${u.records}. Значения в них сохранятся и вернутся вместе с ${kind === 'field' ? 'полем' : 'значением'}.` : 'В записях не используется.'}</li>
            {u.views.length > 0 && <li>Виды, где оно в колонках или фильтре: {u.views.join(', ')}.</li>}
            {u.automations.length > 0 && <li>Сценарии, где оно упомянуто: {u.automations.join(', ')} — проверьте их после архива.</li>}
          </ul>
        )}
        <div className={s.actions}><Button onClick={onClose}>Отмена</Button><Button variant="danger" disabled={!u} onClick={() => { onConfirm(); onClose(); }}>В архив</Button></div>
      </div>
    </Dialog>
  );
}
